import angular from 'angular';
import uirouter from 'angular-ui-router';
import routing from './routes';

import panel from '../../services';

import AppController from './AppController';

import socialLogin from '../../directives/socialLogin';

import isUnique from '../../directives/isUnique';

import isValidPassword from '../../directives/isValidPassword';

import isValidPostalCode from '../../directives/isValidPostalCode';

import appPaymentPlans from '../../directives/appPaymentPlans';
import userLoggedInHeader from '../../directives/userLoggedInHeader';
import userLoggedOutHeader from '../../directives/userLoggedOutHeader';

export default angular.module('app.app', [uirouter, panel, socialLogin, isUnique, isValidPassword, isValidPostalCode, appPaymentPlans, userLoggedInHeader, userLoggedOutHeader])
    .config(routing)
    .controller('AppController', AppController)
    .name;



// WEBPACK FOOTER //
// ./src/app/features/index/index.js